if (!customElements.get('hdt-about-timeline')) {
  class HdtAboutTimeline extends HTMLElement {
    connectedCallback() {
      this.slider = this.querySelector('hdt-slider');
      this.buttons = Array.from(this.querySelectorAll('[data-story-index]'));

      if (!this.slider || !this.buttons.length) {
        return;
      }

      this.onButtonClick = this.onButtonClick.bind(this);
      this.onSliderChange = this.onSliderChange.bind(this);

      this.buttons.forEach((button) => {
        button.addEventListener('click', this.onButtonClick);
      });

      this.slider.addEventListener('init:slide', this.onSliderChange);
      this.slider.addEventListener('select:slide', this.onSliderChange);

      const yearsContainer = this.querySelector('.abt-story__years');

if (yearsContainer) {
  let isDown = false;
  let startX;
  let scrollLeft;

  yearsContainer.addEventListener('mousedown', (e) => {
    isDown = true;
    yearsContainer.classList.add('is-dragging');

    startX = e.pageX - yearsContainer.offsetLeft;
    scrollLeft = yearsContainer.scrollLeft;
  });

  yearsContainer.addEventListener('mouseleave', () => {
    isDown = false;
    yearsContainer.classList.remove('is-dragging');
  });

  yearsContainer.addEventListener('mouseup', () => {
    isDown = false;
    yearsContainer.classList.remove('is-dragging');
  });

  yearsContainer.addEventListener('mousemove', (e) => {
    if (!isDown) return;

    e.preventDefault();

    const x = e.pageX - yearsContainer.offsetLeft;
    const walk = (x - startX) * 2;

    yearsContainer.scrollLeft = scrollLeft - walk;
  });
}

    }

    disconnectedCallback() {
      this.buttons?.forEach((button) => {
        button.removeEventListener('click', this.onButtonClick);
      });

      this.slider?.removeEventListener('init:slide', this.onSliderChange);
      this.slider?.removeEventListener('select:slide', this.onSliderChange);
    }

    onButtonClick(event) {
      const button = event.currentTarget;
      const index = Number(button.dataset.storyIndex);

      if (Number.isNaN(index) || !this.slider?.goToIndex) {
        return;
      }

      this.slider.goToIndex(index, true);
    }

    onSliderChange(event) {
      const sliderApi = event.detail?.sliderApi;

      if (!sliderApi) {
        return;
      }

      const activeIndex = sliderApi.selectedScrollSnap();

      this.buttons.forEach((button, index) => {
        const isActive = index === activeIndex;

        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      const activeButton = this.buttons[activeIndex];
      activeButton?.scrollIntoView({
        behavior: 'smooth',
        inline: 'nearest',
        block: 'nearest'
      });
    }
  }

  customElements.define('hdt-about-timeline', HdtAboutTimeline);
}
